export default __webpack_public_path__ + "static/char-s-38-zh-Hans-27c5c236ad6142716e9bbd2bf85b2ce7.webp";